// extracted by mini-css-extract-plugin
module.exports = {"wrap":"src-pages-business-components-whiteBox-components-DefaultContainer-__index__wrap--2XGxX"};